import React from "react";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import GoogleLogin from "react-google-login";
import styled from "styled-components";
import FacebookButton from "./FacebookButton";
import GoogleButton from "./GoogleButton";

import Loginform from "./Loginform";
import "../styles/LoginPage.css";
import { API_ROOT } from "../util/constants";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginError: false,
      redirect: ""
    };
  }

  componentDidMount() {
    let redirect = document
      .getElementById("login-container")
      .getAttribute("data-redirect");
    this.setState({
      redirect: redirect
    });
  }

  loginSocial = (res, type) => {
    let postData;
    let myRequestUrl = API_ROOT + "signup.php";
    if (type === "facebook" && res.email) {
      postData = {
        name: res.name,
        first_name: res.first_name,
        last_name: res.last_name,
        gender: res.gender,
        provider: type,
        email: res.email,
        provider_id: res.id,
        token: res.accessToken,
        provider_pic: res.picture.data.url
      };
    }
    if (type === "google" && res.w3.U3) {
      postData = {
        name: res.w3.ig,
        first_name: res.w3.ofa,
        last_name: res.w3.wea,
        provider: type,
        email: res.w3.U3,
        provider_id: res.El,
        token: res.Zi.access_token,
        provider_pic: res.w3.Paa,
        gender: ""
      };
    }
    var jsonEncoded = JSON.stringify(postData);
    var formData = new FormData();

    formData.append("userData", jsonEncoded);
    var xhr = new XMLHttpRequest();
    var self = this;
    xhr.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        var res = JSON.parse(this.responseText);
        if (res.status) {
          window.location.href = self.state.redirect;
        }
      }
    };

    xhr.open("POST", myRequestUrl, true);
    xhr.send(formData);
  };
  render() {
    const responseFacebook = response => {
      this.loginSocial(response, "facebook");
    };

    const responseGoogle = response => {
      this.loginSocial(response, "google");
    };
    return (
      <Container>
        <FacebookLogin
          appId="309421312498803"
          autoLoad={false}
          fields="first_name,last_name,email,picture.type(large),gender"
          callback={responseFacebook}
          disableMobileRedirect={true}
          cookie={true}
          isDisabled={false}
          render={renderProps => (
            <FacebookButton onClick={renderProps.onClick}>
              Login with Facebook
            </FacebookButton>
          )}
        />
        <GoogleLogin
          clientId="122886612551-o7p73gclfo8cqsup78mskkcdtkjmkaqi.apps.googleusercontent.com"
          onSuccess={responseGoogle}
          onFailure={responseGoogle}
          render={renderProps => (
            <GoogleButton onClick={renderProps.onClick}>
              Login with Google
            </GoogleButton>
          )}
        />
        <Or>
          <OrText>or</OrText>
        </Or>
        <Loginform redirect={this.state.redirect} />
      </Container>
    );
  }
}

const Container = styled.div`
  width: 90%;
  max-width: 400px;
  padding: 2rem 1rem;
  border-radius: 3px;
  background-color: #ffffff;

  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
`;

const Or = styled.div`
  width: 100%;
  margin: 0.8rem 0;

  display: flex;
  justify-content: center;
  align-items: center;
`;
const OrText = styled.p`
  font-size: 1.15rem;
  color: #484848;
  margin: 0;
`;

export default LoginPage;



// WEBPACK FOOTER //
// ./src/components/LoginPage.js